export default __webpack_public_path__ + "static/media/drum.6687f29f.mp4";